import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { token } from '@atlaskit/tokens';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { IconButton } from '@atlaskit/button/new';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import RetryIcon from '@atlaskit/icon/core/retry';
import DeleteIcon from '@atlaskit/icon/core/delete';

const aiUnsplashHeaderToolbar = xcss({
	// @ts-expect-error
	backgroundColor: token('elevation.surface'),
	right: '20px',
	bottom: '20px',
	borderRadius: 'radius.medium',
	paddingBlock: 'space.050',
	paddingInline: 'space.100',
	position: 'absolute',
	display: 'flex',
	justifyContent: 'center',
	zIndex: '1',
});

const separatorStyles = xcss({
	background: token('color.border'),
	width: '1px',
	height: '20px',
	display: 'inline-block',
	marginInline: 'space.100',
	userSelect: 'none',
});

const seperator = <Box xcss={separatorStyles} />;

const i18n = defineMessages({
	acceptLabel: {
		id: 'page-cover-picture.ai-unsplash-toolbar.accept',
		defaultMessage: 'Accept image',
		description: 'Aria label for accept button in AI Unsplash header toolbar',
	},
	regenerateLabel: {
		id: 'page-cover-picture.ai-unsplash-toolbar.regenerate',
		defaultMessage: 'Regenerate image',
		description: 'Aria label for regenerate button in AI Unsplash header toolbar',
	},
	removeLabel: {
		id: 'page-cover-picture.ai-unsplash-toolbar.remove',
		defaultMessage: 'Remove image',
		description: 'Aria label for remove button in AI Unsplash header toolbar',
	},
});

type AIUnsplashHeaderToolbarProps = {
	onAccept: () => void;
	onRegenerate: () => void;
	onRemoveImage: () => void;
	isRegeneratingImage: boolean;
};

export const AIUnsplashHeaderToolbar = ({
	onAccept,
	onRegenerate,
	onRemoveImage,
	isRegeneratingImage,
}: AIUnsplashHeaderToolbarProps) => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={aiUnsplashHeaderToolbar} testId="AIUnsplashHeaderToolbar">
			<IconButton
				onClick={onAccept}
				icon={CheckCircleIcon}
				appearance="subtle"
				spacing="compact"
				testId="AIUnsplashHeaderToolbar-accept"
				label={formatMessage(i18n.acceptLabel)}
			/>
			{seperator}
			<IconButton
				onClick={!isRegeneratingImage ? onRegenerate : undefined}
				isLoading={isRegeneratingImage}
				icon={RetryIcon}
				appearance="subtle"
				spacing="compact"
				testId="AIUnsplashHeaderToolbar-regenerate"
				label={formatMessage(i18n.regenerateLabel)}
			/>
			{seperator}
			<IconButton
				onClick={onRemoveImage}
				icon={DeleteIcon}
				appearance="subtle"
				spacing="compact"
				testId="AIUnsplashHeaderToolbar-remove"
				label={formatMessage(i18n.removeLabel)}
			/>
		</Box>
	);
};
